var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVoice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2846 9H17.7296C12.2696 9 9.01465 12.255 9.01465 17.715V30.27C9.01465 35.73 12.2696 38.985 17.7296 38.985H30.2846C35.7446 38.985 38.9996 35.73 38.9996 30.27V17.715C38.9996 12.255 35.7446 9 30.2846 9Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 28.3354C14.385 28.3354 13.875 27.8254 13.875 27.2104V20.7754C13.875 20.1604 14.385 19.6504 15 19.6504C15.615 19.6504 16.125 20.1604 16.125 20.7754V27.2104C16.125 27.8404 15.615 28.3354 15 28.3354Z",
    fill: "#111827"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 30.4796C18.885 30.4796 18.375 29.9696 18.375 29.3546V18.6445C18.375 18.0295 18.885 17.5195 19.5 17.5195C20.115 17.5195 20.625 18.0295 20.625 18.6445V29.3546C20.625 29.9846 20.115 30.4796 19.5 30.4796Z",
    fill: "#111827"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 32.625C23.385 32.625 22.875 32.115 22.875 31.5V16.5C22.875 15.885 23.385 15.375 24 15.375C24.615 15.375 25.125 15.885 25.125 16.5V31.5C25.125 32.115 24.615 32.625 24 32.625Z",
    fill: "#111827"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 30.4796C27.885 30.4796 27.375 29.9696 27.375 29.3546V18.6445C27.375 18.0295 27.885 17.5195 28.5 17.5195C29.115 17.5195 29.625 18.0295 29.625 18.6445V29.3546C29.625 29.9846 29.115 30.4796 28.5 30.4796Z",
    fill: "#111827"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33 28.3354C32.385 28.3354 31.875 27.8254 31.875 27.2104V20.7754C31.875 20.1604 32.385 19.6504 33 19.6504C33.615 19.6504 34.125 20.1604 34.125 20.7754V27.2104C34.125 27.8404 33.615 28.3354 33 28.3354Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoice);
export default __webpack_public_path__ + "static/media/voice.c7453d9b0565e5ff3750b68e2cf10a2a.svg";
export { ForwardRef as ReactComponent };